// import { configureStore } from "@reduxjs/toolkit";
import cartslice from "./slices/slice";
// export const store = configureStore({
//   reducers: {

//   },
// });
import { configureStore } from "@reduxjs/toolkit";
import { combineReducers } from "redux";
const reducer = combineReducers({
  cart: cartslice,
});
const store = configureStore({
  reducer,
});
export default store;
